export enum UserRole {
  user = 3,
  admin = 1,
  parent = 2
}


export const token = "TOKEN"
export const role = "ROLE"